import axiosInstance from 'Plugins/axios'
import { localset, localget } from 'Utils/storage.js'
import api from 'Plugins/api'

export function standardSSO (req) {
  return new Promise((resolve, reject) => {
    var param = {}
    console.log(req)
    if( !req.ssotoken||req.ssotoken&&req.ssotoken.length!= 32 ){
      reject()
      throw '-1|token失效！'
    }else{
      param.loginName = req.ssotoken
      param.password = req.ssotoken
      param.loginType = '10'
    }
    //将登录token缓存到浏览器本地储存
    axiosInstance.defaults.headers['token'] = req.ssotoken
    localset('access_token', req.ssotoken)
    // 获取员工信息 
    api['user/getLoginUserInfo']({
      refresh: 1
    }).then((resp2) => {
      resolve(resp2.data)
      localset('userInfo', resp2.data)
      if (resp2.errCode == 100||resp2.errCode == 101) {
        alert('token失效！')
        reject()
      }
      console.log(resp2)
      redirect(req)
    }).catch(() => {
      console.log('failed')
      reject()
    })
  })
}

/**
 * 单点登录重定向 obj
 * @param params 后台需要传入的参数 { a:1, b:2 }
 */
function redirect (params) {
  var ssoPage = params.ssoPage,
    ssoCplx = params.ssoCplx,
    ssoDjlx = params.ssoDjlx  //单据类型
  delete params.ssoPage
  delete params.ssoCplx
  delete params.ssotoken
  delete params.loginType
  delete params.ssoDjlx
  var userInfo = localget('userInfo')
  var orderId=''
  var orderNo=''
  var travelNo = ''
  console.log(userInfo.empInfo)
  if(userInfo.empInfo.ssoJsonParam) {
    let ssoJsonParam=JSON.parse(userInfo.empInfo.ssoJsonParam)
    orderId = ssoJsonParam.orderId
    orderNo = ssoJsonParam.orderNo
    travelNo = ssoJsonParam.travelNo || ssoJsonParam.travelId
    delete userInfo.empInfo.ssoJsonParam // 使用一次就删掉
    localset('userInfo', userInfo)
  }
  /**
     * 单点登录
     * cplx: 根据产品类型跳转到对应产品
     * type: ssoPage：产品的查询页面， ssoCplx：产品的列表页面， 剩余的属性是需要填入页面的参数 ...
     */
  function jump (baseURL) {
    console.log(baseURL)
    if (orderId) {
      // router.push({ path: baseURL, query: { orderId: orderId } })
      location.href=location.origin+'/#'+baseURL+'?orderId='+orderId
    } else if (orderNo) {
      // router.push({ path: baseURL, query: { orderId: orderNo } })
      location.href=location.origin+'/#'+baseURL+'?orderId='+orderNo
    } else if (travelNo) {
      // router.push({ path: baseURL, query: { ccsqdId: travelNo } })
      location.href=location.origin+'/#'+baseURL+'?ccsqdId='+travelNo
    } else { 
      // router.push({ path: baseURL })
      location.href = location.origin + '/#' + baseURL
      console.log('跳转')
    }
    window.location.reload()
    // callback()
  }
  let obj={
    '11001':'/tk/tkOrderDetail',
    '11002':'/tk/tkRefundDetail',
    '11003':'/tk/tkChangeDetail',
    '11004':'/tk/tkOrderDetail',
    '11005':'/tk/tkRefundDetail',
    '11006':'/tk/tkChangeDetail',
    '11007':'/ht/htOrder/htOrderDetail',
    '11008':'/ht/htOrder/htRefundDetail',
    '11009':'/tr/OrderDetail',
    '11010':'/tr/RefundDetail',
    '11011':'/tr/ChangeDetail',
    '11018':'/car/carOrderDetail',
    '':'/allorder'
  }
  console.log(ssoPage)
  switch (ssoPage) {
    case 'query': 
      switch (ssoCplx) {
        case $dict.PRO_TYPE.tk: // 国内机票查询页
          jump('/tk/tkQuery')
          break
        case $dict.PRO_TYPE.tkIntel:// 国际机票查询页
          jump('/tk/tkQuery')
          break
        case $dict.PRO_TYPE.hotel:// 酒店查询页
          jump('/ht/htQuery')
          break
        case $dict.PRO_TYPE.tr:// 火车查询页
          jump('/tr/trQuery')
          break
        case $dict.PRO_TYPE.car:// 用车查询页
          jump('/car/carQuery')
          break
        case $dict.PRO_TYPE.visa:// 签证查询页
          jump('/visa')
          break
      }
      break
    case 'order':
      jump('/allorder')
      break
    case 'detail': // 各详情
      jump(obj[ssoDjlx])
      break
    case 'index': // 主页
      jump('/home')
      break
    case 'allorder':// 全部订单列表
      jump('/allorder')
      break
    default:
      jump('/login')
      break
  }
}